export var ShowStationMarkCommand = function(eventArg){
	this.showStationMark = eventArg;
}
ShowStationMarkCommand.prototype = {
	constructor : ShowStationMarkCommand,
	exec : function(vueScope){
		vueScope.model.roadunits.map(roadUnit => {
            if (this.showStationMark){
              roadUnit.showStationMark();
            }
            else{
              roadUnit.hideStationMark();
            }
            
        });
	}

}


// WEBPACK FOOTER //
// ./src/plugins/components/Web3dModels/commands/ShowStationMarkCommand.js